import React from 'react';
import { ToggleButton, Popup } from '@leverege/ui-elements';
import { Toolbar } from '@leverege/ui-plugin';
import i18n from '@leverege/i18n';
import { jsx as _jsx } from "react/jsx-runtime";
const {
  t,
  tIcon
} = i18n.ns('ui-attributes.detail.customText.textEditor.editors.widgets.ParagraphEditor');
export default function ValueEditor(props) {
  const {
    context,
    active
  } = props;
  const renderTrigger = ({
    ref,
    onToggle,
    isOpened
  }) => {
    return /*#__PURE__*/_jsx(ToggleButton, {
      title: t('title'),
      variant: "customTextParagraphEditor|customText",
      value: active,
      onChange: onToggle,
      domRef: ref,
      icon: tIcon('button', 'fa-solid fa-paragraph')
    });
  };
  return /*#__PURE__*/_jsx(Popup, {
    trigger: renderTrigger,
    children: /*#__PURE__*/_jsx(Toolbar, {
      variant: "customTextMenu|customText",
      hideIfEmpty: true,
      matchContext: {
        use: 'ParagraphEditor',
        client: 'CustomTextModelEditor'
      },
      context: context
    })
  });
}